<!--Navigation Bar-->
<app-navbar>
    <h2>{{'BRAND.BRAND_TITLE' | translate}}</h2>
</app-navbar>
<section class="ptb-70">
    <div class="container">
        <div class="row" [innerHTML]="'BRAND.BRAND_HTML' | translate"></div>
    </div>
</section>

<!--Footer-->
<app-footer></app-footer>